import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BASE}/api` });

// Attach JWT on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vitality_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Helper to surface backend error messages
export const errMsg = (e, fallback = 'Something went wrong') =>
  e?.response?.data?.detail || e?.message || fallback;

export default api;
